import React from 'react'


export default function Loader() {
  return (
    <div className='bg-light p-5 text-center mb-5'> 
        <div class="spinner-grow text-danger" role="status"> </div>
        <div class="spinner-grow text-danger" role="status"> </div>
        <div class="spinner-grow text-danger" role="status"> </div>
        <p className='text-muted mt-3'>Cargando menu ...</p>
    </div>
  )
}